import { BrowserRouter as Router, Switch } from 'react-router-dom';
import Path from './enums/path';
import AuthPage from './pages/auth.page';
import AuthorizedPage from './pages/authorized.page';
import AuthRoute from './routes/auth.route';
import AuthorizedRoute from './routes/authorized.route';
import { AppContext } from 'contexts';
import React, { useState, useCallback } from 'react';
import { useModal } from 'hooks';
import { Image } from 'components/commons';
import { CautionSign } from 'images';
import CssBaseline from '@material-ui/core/CssBaseline';
import { StylesProvider } from '@material-ui/core/styles';
import ErrorPage from 'pages/error.page';
import { CarCrash } from 'images';
import UnauthorizedPage from 'pages/unauthorized.page';

function App() {
  const [appState, setAppState] = useState({ loading: false });
  const errorModal = useModal();

  const [pageError, setPageError] = useState(false);
  const [errorStatus, setErrorStatus] = useState(null);

  const toggleLoading = useCallback((loading) => {
    setAppState((state) => {
      return { ...state, loading };
    });
  }, []);

  return (
    <AppContext.Provider
      value={{
        toggleLoading,
        errorModal,
        appState,
        pageError,
        setPageError,
        errorStatus,
        setErrorStatus
      }}
    >
      <StylesProvider injectFirst>
        <CssBaseline />
        <div className="App">
          {pageError ? (
            errorStatus === 403 || errorStatus === 401 ? (
              <UnauthorizedPage />
            ) : (
              <ErrorPage />
            )
          ) : (
            <Router>
              <Switch>
                <AuthRoute path={Path.Auth} component={AuthPage} />
                <AuthorizedRoute path={Path.Slash} component={AuthorizedPage} />
              </Switch>
            </Router>
          )}
        </div>
      </StylesProvider>
      <div className="render-offline-images">
        <Image src={CautionSign} />
        <Image src={CarCrash} />
      </div>
    </AppContext.Provider>
  );
}

export default App;
